@use '../../style/theme';
@use '../../style/rest';

.stripe-link-authentication-wrap {
  @include rest.rest;

  display: block;
  width: 100%;
  background: #fff;
  padding: 16px;

  .stripe-link-authentication-container {
    #link-authentication-element {
      .StripeElement {
        padding: 8px 16px;
        min-height: 64px;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;

        > .__PrivateStripeElement {
          width: 100%;
        }
      }
    }

    .stripe-element-errors {
      margin-top: 8px;
      font-size: 14px;
      color: var(--color-text-error);
    }
  }
}
